import type { CrudSort } from '@refinedev/core'
import { useList } from '@refinedev/core'

import type { Appointment, AppointmentStatus } from '../types'

import type { OsaEnvironment } from '@/shared/types'

interface UseAppointmentsProps {
  pagination?: {
    current?: number
    pageSize?: number
  }
  filters?: {
    status?: AppointmentStatus
    query?: string
    env?: OsaEnvironment
    type?: string
    subtype?: string[]
    funnel?: string
  }
  sorters?: {
    field?: string
    order?: 'asc' | 'desc'
  }
}

export const useAppointments = (props: UseAppointmentsProps = {}) => {
  const { pagination = { current: 1, pageSize: 10 }, filters, sorters } = props

  const refineFilters = []
  if (filters?.status && filters.status !== 'all') {
    refineFilters.push({
      field: 'status',
      operator: 'eq' as const,
      value: filters.status,
    })
  }
  if (filters?.query) {
    refineFilters.push({
      field: 'q',
      operator: 'eq' as const,
      value: filters.query,
    })
  }
  if (filters?.env) {
    refineFilters.push({
      field: 'env',
      operator: 'eq' as const,
      value: filters.env,
    })
  }
  if (filters?.type) {
    refineFilters.push({
      field: 'type',
      operator: 'eq' as const,
      value: filters.type,
    })
  }
  if (filters?.subtype && filters.subtype.length > 0) {
    refineFilters.push({
      field: 'subtype',
      operator: 'eq' as const,
      value: filters.subtype,
    })
  }
  if (filters?.funnel) {
    refineFilters.push({
      field: 'funnel',
      operator: 'eq' as const,
      value: filters.funnel,
    })
  }

  const refineSorters: CrudSort[] = []
  if (sorters?.field) {
    refineSorters.push({
      field: sorters.field,
      order: sorters.order || 'desc',
    })
  } else {
    // Default sorting
    refineSorters.push({
      field: 'scheduleStartTime',
      order: 'desc',
    })
  }

  const result = useList<Appointment>({
    resource: 'appointments',
    pagination,
    filters: refineFilters,
    sorters: refineSorters,
  })

  return {
    ...result,
    refetch: result.refetch,
  }
}
